export const formatCurrency = (number, symbol = "₮") => {
  const formattedNumber = Math.ceil(number)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${formattedNumber}${symbol}`;
};

export const formatThousandify = (value) => {
  const rawValue = value.replace(/,/g, ""); // Remove existing commas
  const numberValue = parseFloat(rawValue);
  if (!isNaN(numberValue)) {
    const formattedValue = new Intl.NumberFormat().format(numberValue);
    return formattedValue;
  } else {
    return "";
  }
};

export const getStatusColor = (id) => {
  switch (id) {
    case 2:
      return "badge bg-danger";
    case 3:
      return "badge bg-warning";
    case 4:
      return "badge bg-info";
    default:
      return "badge bg-secondary";
  }
};
